import { render, staticRenderFns } from "./WarehouseSelection.vue?vue&type=template&id=3b927cb9&scoped=true&"
import script from "./WarehouseSelection.vue?vue&type=script&lang=js&"
export * from "./WarehouseSelection.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseSelection.vue?vue&type=style&index=0&id=3b927cb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b927cb9",
  null
  
)

export default component.exports